/** Dark band behind the shared transactional-email footer (matches server mail templates). */
export const EMAIL_COMMON_FOOTER_BG = "#0b3558";

/** Shared social + legal block used across GTsetu transactional emails. */
export function emailFooterSocialIconsHtml(): string {
  return `<div style="margin:20px 0;">

              <a href="https://www.linkedin.com/company/gt-setu/" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                  <img src="https://gtsetu.com/wp-content/uploads/2026/02/2.png" height="18" alt="LinkedIn" style="display:block;">
                </a>

              <a href="https://www.instagram.com/gtsetu/" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                  <img src="https://gtsetu.com/wp-content/uploads/2026/02/3.png" height="18" alt="Instagram" style="display:block;">
                </a>

              <a href="https://x.com/gt_setu" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                  <img src="https://gtsetu.com/wp-content/uploads/2026/02/4.png" height="18" alt="X" style="display:block;">
                </a>

              <a href="https://in.pinterest.com/GT_Setu/" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                  <img src="https://gtsetu.com/wp-content/uploads/2026/02/5.png" height="18" alt="Pinterest" style="display:block;">
                </a>

              <a href="https://www.facebook.com/people/GT-Setu/61587851139311/" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                  <img src="https://gtsetu.com/wp-content/uploads/2026/02/6.png" height="18" alt="Facebook" style="display:block;">
                </a>

              <a href="https://www.youtube.com/@GTSetu" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                  <img src="https://gtsetu.com/wp-content/uploads/2026/05/GTsetu-Youtube.png" height="18" alt="YouTube" style="display:block;">
                </a>
                <a href="https://gtsetu.com/support/" style="margin:0 6px; display:inline-block; background:#ffffff; border-radius:50%; padding:7px;">
                    <img src="https://gtsetu.com/wp-content/uploads/2026/02/7.png" height="18" alt="Support" style="display:block;">
                  </a>

              </div>`;
}

/** Tagline, social icons, copyright, contact; optional automated notice. */
export function emailCommonFooterContentHtml(options?: {
  includeAutomatedNotice?: boolean;
  taglineFontSize?: string;
}): string {
  const taglineFontSize = options?.taglineFontSize ?? "15px";
  const includeAutomatedNotice = options?.includeAutomatedNotice !== false;
  const automated = includeAutomatedNotice
    ? `
            <p style="font-size:11px; color:#cfd8e3; margin-top:10px;">
              This is an automated message. Please do not reply.
            </p>`
    : "";
  return `
            ${emailFooterSocialIconsHtml()}

            <p style="font-size:12px; color:#cfd8e3; margin:5px 0;">
              © 2026 GTsetu. All rights reserved.
            </p>

            <p style="font-size:12px; color:#cfd8e3; margin:5px 0;">
              Need help? Contact us at
              <a href="mailto:info@gtsetu.com" style="color:#ffffff; text-decoration:underline;">
                info@gtsetu.com
              </a>
            </p>${automated}`;
}

/** Full footer table row: dark band + {@link emailCommonFooterContentHtml}. */
export function emailCommonFooterRowHtml(options?: {
  tdPadding?: string;
  includeAutomatedNotice?: boolean;
  taglineFontSize?: string;
}): string {
  const tdPadding = options?.tdPadding ?? "35px";
  return `<tr>
          <td style="background-color:${EMAIL_COMMON_FOOTER_BG}; color:#ffffff; text-align:center; padding:${tdPadding};">

            ${emailCommonFooterContentHtml(options)}

          </td>
        </tr>`;
}
